import { useState } from "react";
import NumberFormat from "react-number-format";
import Button from "../Button";
import {

  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Typography,
  message,
} from "antd";
import apiBolsa from "../../services/bolsa-api";
import { FaWallet } from "react-icons/fa";
import { PrevidenciaContainer, Question } from "./styles";
import { currencyToNumber, download, downloadPDF, formatCurrency, isMobile } from "../../utils";
import { InfoCircleOutlined } from "@ant-design/icons";
import { HiOutlineDownload } from "react-icons/hi";
import { useClients } from "../../contexts/ClientsContext";

interface ResumeData {
  m: number;
  o: number;
  ganho: number;
  completa: { valorRestituicao: number };
  simplificada: { valorRestituicao: number };
}

export const Previdencia: React.FC<any> = () => {
  const [form] = Form.useForm();
  const { selectedClient } = useClients();
  const [resume, setResume] = useState<ResumeData>();
  const [loading, setLoading] = useState(false);
  const [editting, setEditting] = useState(true);
  const [activeTabRenda, setActiveTabRenda] = useState<any>("mensal");
  const [activeTabSaude, setActiveTabSaude] = useState<any>("anual");
  const [activeTabEducacao, setActiveTabEducacao] = useState<any>("anual");
  const [activeTabPensao, setActiveTabPensao] = useState<any>("anual");
  const [valuesToReport, setValuesToReport] = useState<any>({});
  const [helpModal, setHelpModal] = useState<any>();
  const [loadingReportPrev, setLoadingReportPrev] = useState(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    const token = localStorage.getItem("@VeloTax:token");
    setValuesToReport(values);
    await apiBolsa
      .post(
        `/velotax/pgblCalculate`,
        {
          rendaBrutaMensalMode: activeTabRenda ?? "mensal",
          rendaBrutaMensal: currencyToNumber(values?.rendaMensal) ?? 0,
          possuiDependentes: values?.dependentes > 0 ? true : false,
          possuiGastoMensalSaudeDependente:
            values?.dependentes > 0 ? true : false,
          possuiGastoMensalEducacaoDependente:
            values?.dependentes > 0 ? true : false,
          pagaPensaoAlimenticia: values?.dependentes > 0 ? true : false,
          quantidadeDependente:
            values?.dependentes > 0 ? values?.dependentes : 0,
          gastoMensalSaudeDependenteMode: "mensal",
          gastoMensalSaudeDependente: 0,
          gastoMensalEducacaoDependenteMode: "mensal",
          gastoMensalEducacaoDependente: 0,
          gastoMensalSaudeMode: activeTabSaude ?? "anual",
          gastoMensalEducacaoMode: activeTabEducacao ?? "anual",
          gastoPensaoAlimenticiaMode: activeTabPensao ?? "anual",
          gastoMensalSaude: currencyToNumber(values?.gastoSaude) ?? 0,
          gastoMensalEducacao: currencyToNumber(values?.gastoEducacao) ?? 0,
          gastoPensaoAlimenticia: currencyToNumber(values?.gastoPensao) ?? 0,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setResume(response.data);
        setEditting(false);
      })
      .catch((err) => {
        console.log(err.message);
        message.error("Algo inesperado aconteceu! Tente novamente mais tarde.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleEdit = () => {
    setEditting(true);
  };

  const SalarioText = (
    <>
      O valor inserido neste campo deve ser sua remuneração, considerando apenas:
      <br />
      <br />
      <ul style={{ listStyle: "outside" }}>
        <li>
        Trabalhadores CLT: salário, adicionais insalubridade/periculosidade,
        adicional noturno, comissões, corretagens, horas extras, bolsa de estudos sem isenção e bonificações.
        Férias e terço de férias devem ser adicionados apenas no "anual", para "mensal" são adicionados automáticamente; 
        </li>
        <li>Empresários: pró-labore;</li>
        <li>Autônomos: rendimentos não-assalariados;</li>
        <li>
          MEI: rendimentos tributáveis, com receita recebida a maior que faixa de
          isenção, e pró-labore.
        </li>
        <li>
          Aposentados com mais de 65 anos: rendimentos acima da faixa de isenção
          por mês (R$ 4.224);
        </li>
        <li>
          Locadores: valores recebidos à título de aluguel.
        </li>
      </ul>
      <br />
      Atenção: Não devem ser incluídos valores recebidos à título de PLR, 13° salário, parcela
      isenta de aposentadoria, diárias e ajuda de custo, remuneração de stock option, 
      dividendos, FGTS, seguro desemprego e indenização paga pelo empregador em caso de demissão ou em caso de acidente de trabalho.
    </>
  );
  
  const EducacaoText = (
    <>
      São aceitos entendidos como despesas com educação aqueles gastos tidos com a
      educação tradicional, que engloba: educação profissional (ensino técnico e o
      tecnológico); educação superior, compreendendo os cursos de graduação e de
      pós-graduação (mestrado, doutorado e especialização); ensino médio; ensino
      fundamental e educação infantil. Importa ressaltar que a dedução é limitada ao valor
      de R$ 3.561,50 por indivíduo.
    </>
  );
  
  const SaudeText = (
    <>
      Consideram-se despesas médicas ou de hospitalização os pagamentos efetuados a
      profissionais da saúde de qualquer especialidade como médicos, dentistas, psicólogos,
      fisioterapeutas, terapeutas ocupacionais, fonoaudiólogos, etc. Além de
      hospitais, despesas provenientes de exames laboratoriais, serviços radiológicos,
      aparelhos ortopédicos, próteses ortopédicas e dentárias e planos de saúde.
    </>
  );
  
  const DependenteText = (
    <>
      A Receita Federal considera como dependentes, para efeito do imposto de
      renda:
      <br />
      1 - Companheiro(a) com quem o contribuinte tenha filho ou viva há mais de 5
      anos, ou cônjuge;
      <br />
      2 - Filho(a) ou enteado(a), até 21 anos de idade;
      <br />
      3 – Filho(a) ou enteado(a) com deficiência, de qualquer idade, quando a sua
      remuneração não exceder as deduções autorizadas por lei (tendo em vista a
      decisão do Supremo Tribunal Federal – STF, na Ação Direta de
      Inconstitucionalidade nº 5.583/DF);
      <br />
      4 - Filho(a) ou enteado(a), se ainda estiverem cursando estabelecimento de
      ensino superior ou escola técnica de segundo grau, até 24 anos de idade;
      <br />
      5 - Irmão(ã), neto(a) ou bisneto(a), sem arrimo dos pais, de quem o
      contribuinte detenha a guarda judicial, até 21 anos, ou em qualquer idade,
      quando incapacitado física ou mentalmente para o trabalho;
      <br />
      6 - Irmão(ã), neto(a) ou bisneto(a), sem arrimo dos pais, com idade de 21
      anos até 24 anos, se ainda estiver cursando estabelecimento de ensino
      superior ou escola técnica de segundo grau, desde que o contribuinte tenha
      detido sua guarda judicial até os 21 anos;
      <br />
      7 - Irmão(ã), neto(a) ou bisneto(a) com deficiência, sem arrimo dos pais,
      do(a) qual o contribuinte detém a guarda judicial, em qualquer idade, quando
      a sua remuneração não exceder as deduções autorizadas por lei (tendo em
      vista a decisão do Supremo Tribunal Federal – STF, na Ação Direta de
      Inconstitucionalidade nº 5.583/DF);
      <br />
      8 - Pais, avós e bisavós que, em 2021, tenham recebido rendimentos,
      tributáveis ou não, até R$ 22.847,76;
      <br />
      9 - Menor pobre até 21 anos que o contribuinte crie e eduque e de quem
      detenha a guarda judicial;
      <br />
      10 – Pessoa absolutamente incapaz, da qual o contribuinte seja tutor ou
      curador.
    </>
  );
  
  const PensaoText = (
    <>
      A Receita só aceita despesas alimentícias definidas em acordo judicial ou
      escritura pública. Outras despesas, mesmo que sejam feitas em prol do
      alimentando, não podem ser incluídas.
    </>
  );
  
  const AnualMensalText = (
    type:
      | "gastos de saúde"
      | "gastos com educação"
      | "gastos com pensão"
      | "renda bruta"
  ) => (
    <>
      Caso selecione a opção <strong>"Anual"</strong>, insira o valor total de{" "}
      {type} que possui no ano. Caso selecione a opção <strong>"Mensal"</strong>,
      insira a média de {type} por mês.
    </>
  );
  
  const HelpModalTexts = {
    rendaBrutaMensal: { body: SalarioText, title: "Salário Bruto" },
    gastoMensalSaude: { body: SaudeText, title: "Gastos com saúde" },
    gastoMensalEducacao: { body: EducacaoText, title: "Gastos com educação" },
    possuiDependentes: { body: DependenteText, title: "Dependentes" },
    pagaPensaoAlimenticia: { body: PensaoText, title: "Gastos com pensão alimentícia" },
    rendaAnualMensal: {
      body: AnualMensalText("renda bruta"),
      title: "Mensal ou anual",
    },
    saudeAnualMensal: {
      body: AnualMensalText("gastos de saúde"),
      title: "Mensal ou anual",
    },
    educacaoAnualMensal: {
      body: AnualMensalText("gastos com educação"),
      title: "Mensal ou anual",
    },
    pensaoAnualMensal: {
      body: AnualMensalText("gastos com pensão"),
      title: "Mensal ou anual",
    },
  };

  return (
    <PrevidenciaContainer>
      <div className="previdencia-card">
        <div className="previdencia-card-content">
          {!resume || editting ? (
            <>
              <Typography.Title className="title">
                Simular economia ao aportar em PGBL
              </Typography.Title>
              <Form
                form={form}
                size="large"
                layout="vertical"
                onFinish={onFinish}
              >
                <Row gutter={[4, 4]} className="rows">
                  <Col className="cols" span={24}>
                    <Form.Item
                      name="rendaMensal"
                      label={<>Salário bruto <Button className="pgbl-info-button" type="text" onClick={() => setHelpModal(HelpModalTexts.rendaBrutaMensal)}>
                      <InfoCircleOutlined />
                      </Button></>}
                      
                      className="form-item"
                      style={{ fontWeight: "bold" }}
                      rules={[
                        {
                          message: "o salário bruto deve ser maior que 0",
                          validator: (_, value) => {
                            if (currencyToNumber(value) > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              "o salário bruto deve ser maior que 0"
                            );
                          },
                        },
                      ]}
                    >
                      
                      <NumberFormat
                        decimalSeparator=","
                        thousandSeparator="."
                        className="ant-input ant-input-lg"
                        prefix="R$ "
                        placeholder="R$ 0,00"
                        decimalScale={2}
                      />
                    </Form.Item>
                    <Select
                      defaultValue="mensal"
                      style={{ width: 120 }}
                      value={activeTabRenda}
                      onChange={(value) => setActiveTabRenda(value)}
                      getPopupContainer={(target) => target.parentElement!}
                    >
                      <Select.Option value="mensal">Mensal</Select.Option>
                      <Select.Option value="anual">Anual</Select.Option>
                    </Select>
                  </Col>
                </Row>

                <Col className="cols" span={24}>
                  <Form.Item
                    name="gastoSaude"
                    label={<>Gastos com saúde <Button className="pgbl-info-button" type="text" onClick={() => setHelpModal(HelpModalTexts.gastoMensalSaude)}>
                      <InfoCircleOutlined />
                      </Button></>}
                    className="form-item"
                    style={{ fontWeight: "bold" }}
                  >
                    <NumberFormat
                      decimalSeparator=","
                      thousandSeparator="."
                      className="ant-input ant-input-lg"
                      prefix="R$ "
                      placeholder="R$ 0,00"
                      decimalScale={2}
                    />
                  </Form.Item>
                  <Select
                    defaultValue="anual"
                    style={{ width: 120 }}
                    value={activeTabSaude}
                    onChange={(value) => setActiveTabSaude(value)}
                    getPopupContainer={(target) => target.parentElement!}
                  >
                    <Select.Option value="mensal">Mensal</Select.Option>
                    <Select.Option value="anual">Anual</Select.Option>
                  </Select>
                </Col>
                <Col className="cols" span={24}>
                  <Form.Item
                    name="gastoEducacao"
                    label={<>Gastos com educação <Button className="pgbl-info-button" type="text" onClick={() => setHelpModal(HelpModalTexts.gastoMensalEducacao)}>
                      <InfoCircleOutlined />
                      </Button></>}
                    className="form-item"
                    style={{ fontWeight: "bold" }}
                  >
                    <NumberFormat
                      decimalSeparator=","
                      thousandSeparator="."
                      className="ant-input ant-input-lg"
                      prefix="R$ "
                      placeholder="R$ 0,00"
                      decimalScale={2}
                    />
                  </Form.Item>
                  <Select
                    defaultValue="anual"
                    style={{ width: 120 }}
                    value={activeTabEducacao}
                    onChange={(value) => setActiveTabEducacao(value)}
                    getPopupContainer={(target) => target.parentElement!}
                  >
                    <Select.Option value="mensal">Mensal</Select.Option>
                    <Select.Option value="anual">Anual</Select.Option>
                  </Select>
                </Col>
                <Col className="cols" span={24}>
                  <Form.Item
                    name="gastoPensao"
                    label={<>Gastos com pensão alimentícia <Button className="pgbl-info-button" type="text" onClick={() => setHelpModal(HelpModalTexts.pagaPensaoAlimenticia)}>
                      <InfoCircleOutlined />
                      </Button></>}
                    className="form-item"
                    style={{ fontWeight: "bold" }}
                  >
                    <NumberFormat
                      decimalSeparator=","
                      thousandSeparator="."
                      className="ant-input ant-input-lg"
                      prefix="R$ "
                      placeholder="R$ 0,00"
                      decimalScale={2}
                    />
                  </Form.Item>
                  <Select
                    defaultValue="anual"
                    style={{ width: 120 }}
                    value={activeTabPensao}
                    onChange={(value) => setActiveTabPensao(value)}
                    getPopupContainer={(target) => target.parentElement!}
                  >
                    <Select.Option value="mensal">Mensal</Select.Option>
                    <Select.Option value="anual">Anual</Select.Option>
                  </Select>
                </Col>
                <Row>
                  <Col span={24}>
                    <Form.Item
                      name="dependentes"
                      label={<>Dependentes <Button className="pgbl-info-button" type="text" onClick={() => setHelpModal(HelpModalTexts.possuiDependentes)}>
                      <InfoCircleOutlined />
                      </Button></>}
                      className="form-item"
                      style={{ fontWeight: "bold" }}
                    >
                      <Input placeholder="0" />
                    </Form.Item>
                  </Col>
                </Row>
                <Button
                  size="middle"
                  type="primary"
                  htmlType="submit"
                  className="full-width"
                  loading={loading}
                
                  style={{  fontSize: "20px", height: "48px"} }
                >
                  SIMULAR ECONOMIA
                </Button>
              </Form>
            </>
          ) : (
            <>
              <Row gutter={[0, 0]}>
                <Question show={true} className="resume-container">
                  <Col span={24} className="col-header">
                    <Typography className="question-title">
                      Diagnóstico:
                    </Typography>
                    <Button
                      className="btn-download"
                      disabled={loadingReportPrev}
                      loading={loadingReportPrev}
                      icon={<HiOutlineDownload color="var(--ant-primary-color)"/>}
                      onClick={async () => {
                        setLoadingReportPrev(true);
                        const token = localStorage.getItem("@VeloTax:token");
                        await apiBolsa.post(
                          `/velotax/pgblCalculate/report`,
                          { content: resume,
                            info: selectedClient,
                            rendaBrutaMensalMode: activeTabRenda ?? "mensal",
                            rendaBrutaMensal: currencyToNumber(valuesToReport?.rendaMensal) ?? 0,
                            possuiDependentes: valuesToReport?.dependentes > 0 ? true : false,
                            possuiGastoMensalSaudeDependente:
                            valuesToReport?.dependentes > 0 ? true : false,
                            possuiGastoMensalEducacaoDependente:
                            valuesToReport?.dependentes > 0 ? true : false,
                            pagaPensaoAlimenticia: valuesToReport?.dependentes > 0 ? true : false,
                            quantidadeDependente:
                            valuesToReport?.dependentes > 0 ? valuesToReport?.dependentes : 0,
                            gastoMensalSaudeDependenteMode: "mensal",
                            gastoMensalSaudeDependente: 0,
                            gastoMensalEducacaoDependenteMode: "mensal",
                            gastoMensalEducacaoDependente: 0,
                            gastoMensalSaudeMode: activeTabSaude ?? "anual",
                            gastoMensalEducacaoMode: activeTabEducacao ?? "anual",
                            gastoPensaoAlimenticiaMode: activeTabPensao ?? "anual",
                            gastoMensalSaude: currencyToNumber(valuesToReport?.gastoSaude) ?? 0,
                            gastoMensalEducacao: currencyToNumber(valuesToReport?.gastoEducacao) ?? 0,
                            gastoPensaoAlimenticia: currencyToNumber(valuesToReport?.gastoPensao) ?? 0,
                          },
                          {
                            headers: {
                              Authorization: `Bearer ${token}`,
                              ispro: 'true'
                            },
                          }
                        )
                        .then((response) => {
                          let fileUrl;
                          let file;
                          if (response) {
                            fileUrl = response?.data?.fileUrl;
                            file = response?.data?.file;
                          }
                          if (fileUrl) {
                            download(fileUrl);
                          } else if (file) {
                            downloadPDF(
                              file,
                              "Previdência"
                            );
                          }
                        })
                        .catch((err) => {
                          console.log(err.message);
                          message.error("Não foi possível baixar o relatório. Tente novamente mais tarde");
                        })
                        .finally(() => {
                          setLoadingReportPrev(false);
                        });
                      }}
                    >
                      Baixar
                    </Button>
                  </Col>
                  {resume.o > 0 ? (
                    <>
                      <Col span={24}>
                        <Row className="restituicao" gutter={[2, 2]}>
                          <Col style={{width: '50%'}}>
                            <Typography.Paragraph>
                              <div className="header-box header-box-black header-border-top">
                                Ganhos totais previstos
                              </div>
                              <div className="content-header with-icon" style={{padding: `${isMobile() ? '8px' : '23px'}`}}>
                                <div className="background-icon-circle" style={{width: '21%'}}>
                                  <FaWallet className="icon-circle"/>
                                </div>
                                <span className="span-text-inside" style={{textAlign: "center", width: '70%'}}>
                                  {formatCurrency(
                                    resume?.ganho
                                  )}
                                </span>
                                
                              </div>
                            </Typography.Paragraph>
                          </Col>
                          <Col style={{width: '48%'}}>
                            <Typography.Paragraph>
                              <div className={`header-box header-border-top ${(resume?.m > 0) ? "header-box-green" : "header-box-red"}`}>
                              Valor a investir em PGBL
                              </div>
                              <div className="content-header">
                                <span className={`${(resume?.m > 0) ? "text-green" : "text-red"} span-text-inside`} 
                                style={{textAlign: "center", width: '100%'}}>
                                  {formatCurrency(
                                    resume?.m
                                  )}
                                </span>
                              </div>
                            </Typography.Paragraph>
                          </Col>
                        </Row>
                        <Row className="row-mobile">
                          <Col style={{width: '70%'}}>
                          <Typography.Paragraph>
                            <div className="header-box header-box-bottom header-box-black header-border-left">
                              Descritivo
                            </div>
                            <div className="content-body text-left border-left-right">
                              Restituição de IRPF na declaração completa, considerando benefícios do PGBL (a)
                            </div>
                            <div className="content-body text-left border-left-right">
                              Restituição de IRPF na declaração simplificada (b)
                            </div>
                            <div className="content-body text-left background-gain border-right-white border-bottom-left-radius">
                              <strong>
                                Ganho total em restituição de IRPF (a - b)
                              </strong>
                            </div>
                          </Typography.Paragraph>
                          </Col>
                          <Col style={{width: '30%'}}>
                          <Typography.Paragraph>
                            <div className="header-box header-box-bottom header-box-black header-border-right">
                              Valor
                            </div>
                            <div className="content-body border-left-right text-center">
                              {formatCurrency(
                                resume?.completa?.valorRestituicao
                              )}
                            </div>
                            <div className="content-body border-left-right text-center">
                              {formatCurrency(
                                resume?.simplificada?.valorRestituicao
                              )}
                            </div>
                            <div className="content-body background-gain border-left-white border-bottom-right-radius text-center">
                              <strong>
                                {formatCurrency(
                                  resume?.completa?.valorRestituicao - resume?.simplificada?.valorRestituicao
                                )}
                              </strong>
                            </div>
                          </Typography.Paragraph>    
                          </Col>
                        </Row>
                      </Col>
                    </>
                  ) : (
                    <Col span={24}>
                      <Typography.Paragraph>
                        Para o seu perfil, investir em VGBL pode ser uma melhor
                        opção.
                      </Typography.Paragraph>
                    </Col>
                  )}
                  <Col span={24}>
                    <Button
                      size="middle"
                      type="primary"
                      htmlType="submit"
                      className="full-width"
                      style={{
                        color: "#000",
                        fontSize: "20px",
                        height: "48px",
                      }}
                      onClick={handleEdit}
                    >
                      EDITAR SIMULAÇÃO
                    </Button>
                  </Col>
                </Question>
              </Row>
              {/* {resume.o > 0 && (
                <Row className="renda-container" gutter={[8, 8]}>
                  <Col span={24}>
                    (1) A economia indicada é baseada na comparação entre a
                    declaração feita de forma completa e desconto simplificado
                  </Col>
                  <Col span={24}>
                    (2) A dedução de imposto de renda por aplicação de PGBL
                    somente é válido para contribuintes do INSS.
                  </Col>
                  <Col span={24}>
                    (3) Os valores simulados são para fins ilustrativos apenas,
                    não englobando a possibilidade de perda no investimento em
                    PGBL
                  </Col>
                </Row>
              )} */}
            </>
          )}
        </div>
      </div>
      {(!resume || editting) &&  (<div className="previdencia-card card-bottom">
        <div className="previdencia-card-content card-bottom-content">
          <Typography.Text className="list-pgbl">
            Seu cliente pode ser elegível para ter economia com aporte em PGBL
            caso se enquadre em algum dos casos abaixo:
          </Typography.Text>
          <div style={{marginLeft: `${ isMobile() ? '20px' : ''}`}}>
            <ul>
              <li>Assalariado (CLT)</li>
              <li>Empresário (recebeu pró-labore)</li>
              <li>Autônomo</li>
              <li>MEI</li>
              <li>Aposentado (rendimentos acima de R$ 4.224,00 por mês)</li>
              <li>Servidor Público</li>
              <li>Recebeu renda de aluguel</li>
            </ul>
          </div>
        </div>
      </div>)}
      <Modal
          footer={null}
          visible={!!helpModal}
          title={helpModal?.title}
          onCancel={() => setHelpModal(undefined)}
        >
          {helpModal?.body}
      </Modal>
    </PrevidenciaContainer>
  );
};
